import { EStorageType } from 'reactApp/modules/storage/storage.types';
import {
    Correspondents,
    UserQuotaCleanerGroup,
    UserQuotaCleanerListParams,
    UserQuotaGroupId,
    UserQuotaGroupType,
} from 'reactApp/types/QuotaCleaner';
import { Kind, SubKind, VirusScan } from 'reactApp/types/Tree';

type AdditionalProps = {
    home?: string;
    isInFavorites?: boolean;
};

export type QuotaCleanerItem = Resolve<
    AdditionalProps & {
        id: string;
        isFolder: boolean;
        isVirus: boolean;
        ext: string;
        nameWithoutExt: string;
        thumbnails?: Record<string, string>;
        subKind: SubKind;
        storage: EStorageType;
        parent: string;
        groupId: UserQuotaGroupId;
        groupType: UserQuotaGroupType;
        deleteId: string;
        viewPath: string;
        correspondents?: Correspondents;
        size: number;
        name: string;
        kind: Kind;
        virusScan: VirusScan;
    }
>;

export type QuotaCleanerGroup = Omit<UserQuotaCleanerGroup, 'list' | 'group_id' | 'group_type' | 'total_count'> & {
    totalCount: number;
    list: Record<string, QuotaCleanerItem>;
    groupId: UserQuotaGroupId;
    groupType: UserQuotaGroupType;
    storage: EStorageType;
    childs: string[];
    id: string;
    isLoading: boolean;
    isLoaded: boolean;
    hasMoreToLoad?: boolean;
};

export enum Sort {
    size = 'size',
    name = 'name',
    date = 'date',
}

export enum Order {
    asc = 'asc',
    desc = 'desc',
}

export interface State {
    groups: QuotaCleanerGroup[] | [];
    groupsParams: Record<UserQuotaGroupId, UserQuotaCleanerListParams> | null;
    currentGroup: QuotaCleanerGroup | null;
    isGroupsLoading: boolean;
    isGroupsLoadingError: boolean;
    isGroupsLoaded: boolean;
    needGroupsReload: boolean;
    isGroupLoadingError: boolean;
    isMessagesRemoveNeeded: boolean;
    isItemsDeleteProcess: boolean;
    isItemsDeleteError: boolean;
}

export type QuotaCleanerGroupParam = UserQuotaCleanerListParams & {
    sort: Sort;
    order: Order;
    offset: number;
    limit: number;
};

export type QuotaCleanerListParam = {
    groups: UserQuotaCleanerListParams[];
};
